import { Efficiency } from "@edp-models/energy-efficiency.model";

export interface WidgetStructure<T> {
    widget: T;
    data: any;
    type: string;
}

export class WidgetStructureFactory {
    public static create<T>(widget: T, data: any, type: string): WidgetStructure<T> {
        return {
            widget,
            data,
            type
        };
    }
}


export class EfficiencyFactory {
    static create(efficiency: Efficiency[]) {

        efficiency.forEach((item) => {
            if (item.name === "energyConsumption") {
                item.title = "pt.edp.edponline.edpe.dashboard.header.powerConsumption";
                item.link = "pt.edp.edponline.more.info";
                item.routerLink = ["/planeta-zero/ganhar-zs/eficiencia-energetica"];
            } else if (item.name === "hints") {
               item.title = "pt.edp.edponline.edpe.dashboard.header.viewedTips";
            } else if (item.name === "individualChallenge") {
               item.title =  "pt.edp.edponline.edpe.dashboard.header.individualChallenges";
               item.link = "pt.edp.edponline.see.challenges";
               item.routerLink = ["/planeta-zero/ganhar-zs/desafios-individuais"];
            } else if (item.name === "collectiveChallenge") {
               item.title = "pt.edp.edponline.edpe.dashboard.header.collectiveChallenges";
               item.link = "pt.edp.edponline.see.challenges";
               item.routerLink = ["/planeta-zero/ganhar-zs/desafios-globais"];
            }

        });
        return efficiency;
    }
}


